import { AnyAction, Store } from "redux"
let myStore:Store<any, AnyAction>

export const toolGetStore = (store:Store<any, AnyAction>)=>myStore = store
export const toolDispatch = (action:any) => myStore.dispatch(action)
export const toolGetState = () => myStore.getState()


